export const matchesKeys = {
  all: (...args) => ["matches", ...args],
  activity: (activityId: string | number, ...args) => ["matches", String(activityId), ...args]
};
